real.locale = (function() {
    'use strict';

    let
        language,
        locale,
        dateFormat,
        timeFormat
    ;

    return {

        init : function(languageParam, localeParam, dateFormatParam, timeFormatParam) {
            language   = languageParam;
            locale     = localeParam;
            dateFormat = dateFormatParam;
            timeFormat = timeFormatParam;
        },

        getDateFormat : function() {
            return dateFormat;
        },

        getTimeFormat : function() {
            return timeFormat;
        },

        getDateFormatByLocale : function(locale) {
            // This should match file: library/Foundation/Utils/LocaleHelper.php
            switch(locale) {
                case 'en_GB' :
                case 'fr_FR' :
                    return 'd/m/Y'; // 24/06/2020

                case 'es_419' :
                    return 'd/m/y'; // 24/06/20

                case 'en_US' :
                    return 'm/d/y'; // 6/24/20

                case 'sv_SE' :
                    return 'Y-m-d'; // 2020-06-24

                case 'nl_NL' :
                    return 'd-m-y'; // 24-06-2020

                case 'nb_NO' :
                case 'da_DK' :
                case 'de_DE' :
                case 'fi_FI' :
                    return 'd.m.Y'; // 24.06.2020
            }

            // Default
            return 'd.m.Y'; // 24.06.2020
        },

        getTimeFormatByLocale : function(locale) {
            switch(locale) {
                case 'en_GB' :
                case 'en_US' :
                    return 'h:i a';
            }

            // Default
            return 'H:i';
        },

        getDateFormatForFlatpickr : function() {
            return real.locale.getDateFormatByLocale(locale);
        },

        getTimeFormatForFlatpickr : function() {
            // Flatpickr uses "K" for am/pm whereas the PHP date and real.date classes
            // use "a" for am/pm. Thus, not using the getTimeFormatByLocale() method.
            switch(locale) {
                case 'en_GB' :
                case 'en_US' :
                    return 'h:i K';
            }

            // Default
            return 'H:i';
        },

        getFirstDayOfTheWeekForFlatpickr : function() {
            switch(locale) {
                case 'en_US' :
                    return 0; // Sunday
            }

            // Default
            return 1; // Monday
        },

        getUse24HourClock : function() {
            switch(locale) {
                case 'en_GB' :
                case 'en_US' :
                    return false;
            }

            // Default
            return true;
        },

        getLanguage : function() {
            return language;
        },

        /**
         * Returns a known language as BCP 47 language code.
         * https://www.techonthenet.com/js/language_tags.php
         */
        getLocaleAsBCP47 : function() {
            return locale.replace(/_/g, '-');
        }
    };

})();
